var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.64917,
    y: 2,
    width: 75.6493,
    height: 75.6493,
    rx: 37.8246,
    stroke: "#FF3F3C",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9971 40.8963C30.0079 35.2221 38.6817 31.481 43.0187 29.6736C55.4158 24.5125 57.9887 23.6161 59.6691 23.5857C60.0386 23.5798 60.8614 23.6712 61.3983 24.1058C61.8445 24.4723 61.97 24.968 62.0328 25.316C62.0886 25.6636 62.1653 26.456 62.1025 27.0745C61.4331 34.1394 58.5256 51.2835 57.0474 59.1965C56.4269 62.5446 55.1927 63.6672 54.0004 63.7768C51.4066 64.0155 49.4404 62.0622 46.9303 60.4154C43.0047 57.8373 40.7874 56.233 36.9735 53.7178C32.5668 50.8108 35.4256 49.2129 37.9357 46.602C38.5911 45.9185 50.0121 35.5202 50.2283 34.5771C50.2562 34.4591 50.284 34.0193 50.0191 33.7875C49.7611 33.555 49.3776 33.6346 49.0987 33.6974C48.7013 33.7868 42.433 37.9391 30.2728 46.1538C28.4949 47.3783 26.8842 47.9751 25.4339 47.9437C23.8442 47.9095 20.7762 47.0418 18.4962 46.3004C15.7072 45.3907 13.483 44.9097 13.6782 43.3648C13.7758 42.5606 14.8844 41.7376 16.9971 40.8963Z",
    fill: "#FF3F3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegram-logo.b2a2e68b0d4e8954f5e7297042f2f2b2.svg";
export { ForwardRef as ReactComponent };